export default "__VITE_ASSET__CkjPnG2T__"